module.exports = __webpack_public_path__ + "img/mapa__americas.b8045c61.png";